import { defineStore } from "pinia";
import { ProfileAdministrationAPI } from "../api";

export const useProductsWithDepartmentsStore = defineStore("productsWithDepartments", {
    state: () => ({
        ppmProducts: [] as string[],
        loaded: false,
    }),
    actions: {
        async ensureLoaded() {
            if (this.loaded) return;

            const products = await ProfileAdministrationAPI.fetchPublicProducts();
            this.ppmProducts = (Array.isArray(products) ? products : [])
                .filter((product) => product.model?.model?.toLowerCase() === "ppm")
                .map((product) => product.productNo);
            this.loaded = true;
        },
        isPpmProduct(productNo: string): boolean {
            return this.ppmProducts.includes(productNo);
        },
    },
});
